import {
  Button,
  Flex,
  Link,
  ModalBody,
  ModalFooter,
  Stack,
} from "@chakra-ui/react";
import LeadConnectorFields from "../../LeadConnectorFields";
import useExternalAuth from "../../../Tools/useExternalAuth";
import SelectTwilioAccount from "../../SelectTwilioAccount";
import SelectPhoneNumber from "../../SelectPhoneNumber";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import useTwilioAccounts from "../../useTwilioAccounts";

export default function LeadConnectorCallForm({
  widgetForm,
  onSubmit,
  loadingStatus,
  onBack,
}) {
  const { watch, setValue, formState } = widgetForm;
  const { errors } = formState

  const { auths: leadConnectorAuths } = useExternalAuth({
    auth_provider: "leadconnector",
  });

  const { accounts, phoneNumbers } = useTwilioAccounts({
    widgetType: watch("widget_type"),
    twilio_auth_id: watch("twilio_auth_id"),
  });

  return (
    <form onSubmit={(e) => { e.preventDefault(); widgetForm.handleSubmit(onSubmit)(); }}>
      <ModalBody>
        <Stack spacing={2}>
          <LeadConnectorFields
            leadConnectorAuths={leadConnectorAuths}
            watch={watch}
            setValue={setValue}
          />
          <SelectTwilioAccount
            accounts={accounts}
            errors={errors}
            watch={watch}
            setValue={setValue}
          />
          <SelectPhoneNumber
            watch={watch}
            setValue={setValue}
            phoneNumbers={phoneNumbers}
          />
          <Flex justifyContent={"flex-start"}>
            <Link
              color={"blue.500"}
              href={
                "https://www.twilio.com/en-us/blog/better-twilio-authentication-csharp-twilio-api-keys"
              }
              isExternal
            >
              Get Keys <ExternalLinkIcon mx="2px" />
            </Link>
          </Flex>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button mr={3} onClick={onBack}>
          Back
        </Button>
        <Button
          type="button" onClick={() => widgetForm.handleSubmit(onSubmit)()}
          isLoading={loadingStatus === "loading"}
          colorScheme={"blue"}
        >
          {"Finish"}
        </Button>
      </ModalFooter>
    </form>
  );
}
